import { Checkbox } from "@fluentui/react";
import {
    Button,
    Popover,
    PopoverSurface,
    PopoverTrigger,
    Switch,
    Text
} from "@fluentui/react-components";
import { PersonMoneyRegular, SettingsRegular } from "@fluentui/react-icons";
import { useState } from "react";

////i18Next
import { useTranslation } from "react-i18next";

// models
import { ContractConcept } from "../../../../../../models/Entities/Contracts/ContractConcept";

export interface IProps {
    concept: ContractConcept;
    isSelected: boolean;
    applyOnlyOnOwnerAmount?: boolean;
    /*
     * The settings affordance only exists for the callers that actually persist
     * the relationship settings; the read only usages keep the plain checkbox.
     */
    onApplyOnlyOnOwnerAmountChange?: (applyOnlyOnOwnerAmount: boolean, conceptId: number) => void;
    onCheckboxChange: (checked: boolean, conceptId: number) => void;
}

export const ProtocolConceptItemComponent = (props: IProps) => {

    const [isSettingsOpen, setIsSettingsOpen] = useState<boolean>(false);

    //useTranslation()
    const [t] = useTranslation();

    const conceptName: string = props.concept?.concept?.conceptName || '';
    // Kept as the accessible label; the visible layout is rendered below.
    const label: string = '[' + props.concept?.id + '] - ' + conceptName;

    const applyOnlyOnOwnerAmount: boolean = props.applyOnlyOnOwnerAmount === true;
    // Configuring a relationship that is not associated yet has no meaning, so the
    // gear is only offered on the concepts the user already checked.
    const isConfigurable: boolean = props.onApplyOnlyOnOwnerAmountChange !== undefined && props.isSelected;

    return (<>
        <Checkbox key={'check' + props.concept.id} label={label} title={label} checked={props.isSelected} onChange={
            (ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined) => {
                props.onCheckboxChange(checked!, props.concept.id);
            }
        } onRenderLabel={() => (
            <span className="ConceptMultiSelectorItemLabel">
                <span className="ConceptMultiSelectorItemId">{props.concept?.id}</span>
                <span className="ConceptMultiSelectorItemName">{conceptName}</span>
                {applyOnlyOnOwnerAmount && props.isSelected && (
                    <span
                        className="ConceptMultiSelectorItemTag"
                        title={t('protocolConceptMultiselector.settings.applyOnlyOnOwnerAmountHint')}
                    >
                        <PersonMoneyRegular fontSize={13} />
                        {t('protocolConceptMultiselector.settings.applyOnlyOnOwnerAmountTag')}
                    </span>
                )}
            </span>
        )} />
        {isConfigurable && (
            <Popover
                open={isSettingsOpen}
                onOpenChange={(event, data) => setIsSettingsOpen(data.open)}
                positioning="before"
                withArrow
                trapFocus
            >
                <PopoverTrigger disableButtonEnhancement>
                    <Button
                        className={applyOnlyOnOwnerAmount
                            ? 'ConceptMultiSelectorItemSettings Active'
                            : 'ConceptMultiSelectorItemSettings'}
                        appearance="subtle"
                        size="small"
                        icon={<SettingsRegular />}
                        title={t('protocolConceptMultiselector.settings.buttonTitle')}
                        aria-label={t('protocolConceptMultiselector.settings.buttonTitle') + ' - ' + label}
                    />
                </PopoverTrigger>
                <PopoverSurface>
                    <div className="ConceptMultiSelectorSettingsPanel">
                        <Text as="h4" block weight="semibold" className="ConceptMultiSelectorSettingsTitle">
                            {t('protocolConceptMultiselector.settings.title')}
                        </Text>
                        <Text block size={200} className="ConceptMultiSelectorSettingsConcept">{label}</Text>
                        <Switch
                            checked={applyOnlyOnOwnerAmount}
                            label={t('protocolConceptMultiselector.settings.applyOnlyOnOwnerAmount')}
                            onChange={(event, data) =>
                                props.onApplyOnlyOnOwnerAmountChange!(data.checked, props.concept.id)
                            }
                        />
                        <Text block size={200} className="ConceptMultiSelectorSettingsHint">
                            {t('protocolConceptMultiselector.settings.applyOnlyOnOwnerAmountHint')}
                        </Text>
                    </div>
                </PopoverSurface>
            </Popover>
        )}
    </>);
}
